<template>
    <div class="body-info body-content-description body-media-container has-footer-absolute themed-scrollbar"
        id="bodyMediaContainer">
        <div class="media-canvas" :class="{ 'not-iphone': !isIOS }" id="mediaCanvas"
            :style="{maxWidth: '100vw', width: `${isDesktop ? '100%' : 'calc(100% - 20px)'}`,margin: `${isDesktop ? null : '0px 10px'}`}">
            <img v-if="fileData" :src="fileData.src" class="contained-ratio cropped-image" :id="imgId" :alt="imgId">
            <div class="media-canvas-size" :style="{ color: `${isDesktop ? '#333' : '#fff'}` }">
                {{ cropWidth }}x{{ cropHeight }}
            </div>
        </div>
        <div class="button-wrapper fit-content modal-absolute">
            <div v-if="warning" v-html="warning"></div>
            <button v-else class="pastime-button dark-mode" @click.prevent="saveImage" :disabled="!fileData"
                id="btnCrop">
                {{ kStrings.kGLOB_USE }}
            </button>
        </div>
    </div>
</template>

<script>

const CHA_MIN_CROPPER_WH = 1300;

import operatingSystem from '@/Utilities/operating-system';
import Cropper from 'cropperjs';

export default {
    name: 'ImageEdit',
    components: {},
    props: {
        prop1: { type: Object, default: null, required: false }
    },
    data() {
        return {
            cropper: null,
            cropWidth: null,
            cropHeight: null
        }
    },
    computed: {
        isDesktop() {
            return this.$store.getters.isDesktop;
        },
        imgId() {
            return this.fileData ? this.fileData.alt : 'uploadFile';
        },
        kStrings() {
            return this.$store.getters.kStrings;
        },
        modalData() {
            return this.$store.getters.modalData;
        },
        fileData() {
            return this.modalData && this.modalData.content ? this.modalData.content : null
        },
        mediaGridUpload() {
            return this.$store.getters['registrationPage/mediaGridUpload'];
        },
        pastimeInfo() {
            return this.$store.getters.pastimeInfo;
        },
        layoutSize() {
            return this.$store.getters.pastimeInfo?.detailedInfo?.mediaLayoutSize ?? 1;
        },
        minCrop() {
            let div = Math.round(this.layoutSize / 2);
            return Math.round(CHA_MIN_CROPPER_WH / div);
        },
        warning() {
            if (this.cropHeight < this.minCrop || this.cropWidth < this.minCrop) {
                let text = this.kStrings?.kPASTIME_ERROR_PHOTO_DIMENSIONS ?? null;
                if (text) {
                    return text.replace('{{width}}', this.minCrop).replace('{{height}}', this.minCrop);
                }
            }
            return null;
        },
        isIOS() {
            return operatingSystem.isIOS();
        },
    },
    mounted() {
        let imgElement = document.getElementById(this.imgId);
        let box = this.fileData?.box ?? null;
        const _this = this;
        this.cropper = new Cropper(imgElement, {
            viewMode: 1,
            aspectRatio: 1,
            autoCropArea: box != null ? 0 : 1,
            responsive: true,
            rotatable: false,
            guides: false,
            checkCrossOrigin: false,
            checkOrientation: false,
            toggleDragModeOnDblclick: false,
            ready() {
                box && this.cropper.setCropBoxData(box);
            },
            crop(e) {
                let data = e.detail;
                _this.cropWidth = Math.round(data.width);
                _this.cropHeight = Math.round(data.height);
            }
        });

        //Blocking Navigation Gestures - Android Add
        if (!this.isDesktop && !this.isIOS) {
            window.addEventListener("beforeunload", this.beforeUnloadListener, { capture: true });
        }
        //Blocking Navigation Gestures - iOS Add
        if (this.isIOS) {
            let elem = document.querySelector('#mediaCanvas');
            elem.addEventListener('touchstart', this.touchstartIOS);
        }
    },
    destroyed() {
        //Blocking Navigation Gestures - Android Remove
        if (!this.isDesktop && !this.isIOS) {
            window.removeEventListener("beforeunload", this.beforeUnloadListener, { capture: true });
        }
        //Blocking Navigation Gestures - iOS Remove
        if (this.isIOS) {
            let elem = document.querySelector('#mediaCanvas');
            if (elem) {
                elem.removeEventListener('touchstart', this.touchstartIOS);
            }
        }
    },
    methods: {
        beforeUnloadListener(ev) {
            ev.preventDefault();
            return ev.returnValue = null;
        },
        touchstartIOS(e) {
            e.preventDefault();
        },
        async saveImage() {
            this.$store.dispatch('setLoading', true);
            setTimeout(() => {
                this.setGridSection();
            }, 100);
        },
        async setGridSection() {
            let croppedFile = null;
            try {
                let maxSize = this.minCrop * 2;
                let imgId   = this.fileData.alt;
                let canvas  = this.cropper.getCroppedCanvas({
                    maxWidth: maxSize > 3000 ? 3000 : maxSize, 
                    maxHeight: maxSize > 3000 ? 3000 : maxSize,
                    minWidth: this.minCrop,
                    minHeight: this.minCrop,
                    fillColor: '#ffffff',
                    imageSmoothingQuality: 'high',
                    imageSmoothingEnabled: false
                });

                if (Math.round(canvas.width) < this.minCrop) {
                    this.cropHeight = Math.round(canvas.height);
                    this.cropWidth  = Math.round(canvas.width);
                    this.$store.dispatch('setLoading', false);
                    return;
                }

                let croppedImage = canvas.toDataURL("image/jpeg");
                let croppedBox   = this.cropper.getCropBoxData();

                canvas.toBlob((blob) => {
                    try {
                        croppedFile = new File([blob], imgId + '.jpg', { type: "image/jpeg" });

                        let parsedGrid = {
                            position: this.fileData.position,
                            type: 'image',
                            mediaData: {
                                original: this.fileData.src,
                                src: croppedImage ? croppedImage : this.fileData.src,
                                alt: this.fileData.alt,
                                file: croppedFile,
                                box: croppedBox ?? null
                            },
                        };
                        this.$store.dispatch('registrationPage/setMediaGridUpload', parsedGrid);
                        this.$store.dispatch('setModalStatus', { status: false, context: null });
                    } catch (e) { }
                    this.$store.dispatch('setLoading', false);
                }, "image/jpeg");
            } catch (e) { 
                this.$store.dispatch('setLoading', false);
            }
        },
    }
};
</script>